const initialState = {
    isOpen: false,
    isFinanceVo: false,
    isHeaderSearch: false,
    isShortCutKey: false,
    isNotification: false,
    wrapperActive: false,
  }
  export default initialState;